import { ReactNode } from 'react';
import styles from '../../bmweDataTable.module.css';
import { tableStrings } from '../../i18n/de-de';

interface EmptyStateRowProps {
  columnsCount: number;
  emptyState?: ReactNode;
}

export function EmptyStateRow({
  columnsCount,
  emptyState,
}: EmptyStateRowProps) {
  return (
    <tr className={styles.bmweDataTableEmptyRow} role="row">
      <td
        colSpan={columnsCount}
        className={styles.bmweDataTableEmptyCell}
        role="gridcell"
      >
        <div
          className={styles.emptyStateContainer}
          role="status"
          aria-live="polite"
        >
          {emptyState ?? <p>{tableStrings.messages.noData}</p>}
        </div>
      </td>
    </tr>
  );
}
